export default function OpretKursusIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 15.764}
      height={height ? height : width ? width : 18.38}
      viewBox="0 0 15.764 18.38"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        data-name="Group 1683"
      >
        <path
          strokeWidth="1.5"
          d="M15.164 9.784V4.848a1.214 1.214 0 0 0-1.214-1.214h-3.64m-4.855 0H1.814A1.214 1.214 0 0 0 .6 4.848v7.282a1.214 1.214 0 0 0 1.214 1.214h3.641m-.607 0-1.823 4.248M7.882.6v1.825"
          data-name="Path 565"
        />
        <path
          strokeWidth="1.5"
          d="M9.096 4.847H6.669a1.214 1.214 0 0 1-1.214-1.214h0v-.607a.607.607 0 0 1 .607-.607h3.641a.607.607 0 0 1 .607.607v.607h0a1.214 1.214 0 0 1-1.214 1.214Z"
          data-name="Path 566"
        />
        <path strokeWidth="1.5" d="M11.6 10.384v6" data-name="Line 359" />
        <path strokeWidth="1.5" d="M8.6 13.384h6" data-name="Line 360" />
      </g>
    </svg>
  );
}
